import { Component, OnInit, Input, Injectable, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ValidatorService } from "../services/validation.service";
import { Router } from '@angular/router';
import { QuestionPageService } from './../services/Question-Page.service';
import { SurveyDeployerQuestionPageRequestJSON } from "./../common/JSON/RequestTOJSON/Survey-Deployer-Question-Page-Request.JSON";
import { SurveyDeployerQuestionsPageResponseJSON } from "./../common/JSON/questionPage/Survey-Deployer-Questions-Page-Response.JSON";
import { QuestionDetailsHeaderRequestJSON } from "./../common/JSON/RequestTOJSON/Question-Details-Header-Request.JSON";
import { QuestionPageDetailsResponseJSON } from "./../common/JSON/questionPage/Question-Page-Details-Response.JSON";
import { QuestionPageDetailsRequestJSON } from "./../common/JSON/questionPage/Question-Page-Details-Request.JSON";
import { QuestionCardResponseJSON } from "./../common/JSON/questionPage/Question-Card-Response.JSON";
import { PageHeaderResponseJSON } from "./../common/JSON/surveyHeader/Page-Header-Response-JSON";
import { PageFooterResponseJSON } from "./../common/JSON/surveyFooter/Page-Footer-Response-JSON";
import { InputHTMLComponentJSON } from "./../common/JSON/htmlComponent/Input-HTML-Component-JSON";
import { LinkedQuestionJSON } from "./../common/JSON/questionPage/Linked-Question.JSON";
import { RequestService } from "../request.service";
import { QuestionDetailsHeaderResponseJSON } from "./../common/JSON/questionPage/Question-Details-Header-Response.JSON";

import { QuestionCardRequestJSON } from "./../common/JSON/questionPage/Question-Card-Request.JSON";
import { QuestionColumnJSON } from "./../common/JSON/questionPage/Question-Column.JSON";
import { QuestionColumnRequestJSON } from "./../common/JSON/questionPage/Question-Column-Request.JSON";
import { CellComponentDetailJSON } from "./../common/JSON/questionPage/Cell-Component-Detail.JSON";
import { CellComponentDetailRequestJSON } from "./../common/JSON/questionPage/Cell-Component-Detail-Request.JSON";
import { CellComponentJSON } from "./../common/JSON/questionPage/Cell-Component.JSON";
import { CellComponentRequestJSON } from "./../common/JSON/questionPage/Cell-Component-Request.JSON";
import { HTMLDisplayComponentRequestJSON } from "./../common/JSON/htmlComponent/HTML-Display-Component-Request.JSON";
import { HTMLGenricComponent } from "./../common/JSON/htmlComponent/HTML-Genric-Component.JSON";
import { HTMLLabelComponent } from "./../common/JSON/htmlComponent/HTML-Label-Component-JSON";
import { QuestionJSON } from "./../common/JSON/questionPage/Question.JSON";
import { QuestionRequestJSON } from "./../common/JSON/questionPage/Question-Request.JSON";
import { QuestionOptionJSON } from "./../common/JSON/questionPage/Question-Option.JSON";
import { QuestionOptionRequestJSON } from "./../common/JSON/questionPage/Question-Option-Request.JSON";
import { DisplayRoleResponseJSON } from "./../common/JSON/questionPage/Display-Role-Response.JSON";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {MatAccordion} from '@angular/material/expansion';
import * as _moment from 'moment';

const moment = _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
      },
      display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
      },
  };

@Component({
    selector: 'questions-page',
    templateUrl: './question.component.html',
    providers: [QuestionPageService,
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
          },
      
          {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
      ],
    styles: [
        `.loader-ring h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
        }
        .thank-you h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
             text-align:center;
        }
        .thank-you p {
            text-align: center;
            word-wrap: break-word;
            width: 250px;
        }
        .loader.container-fluid {

            background: #ffffff none repeat scroll 0 0;
            height: 78px;
            position: relative;
            z-index: 5;
        }

        .loader-ring.text-container {
            margin: 10% auto;
        }

        .logo-image {

            width: auto;
            float: left;
            margin: 14px;
        }
        
        .thank-you h1 {
            color: #555;
            font-size: 2em;
            font-weight: 400;
        }
        
        .thank-you p {
            margin: 0 auto;
            width: 280px;
        }

        img.loader {
            position: absolute;
            top: 50%;
            left: 46%;
        }`
    ]
})

export class QuestionPageComponent implements OnInit {
    @Input() error;
    @Input() loading;
    @Input() expire;
    @Input() thanks;

    // @Input() questionDetailsHeaderRequestJSON: QuestionDetailsHeaderRequestJSON;
    @Input() surveyDeployerQuestionPageRequestJSON: SurveyDeployerQuestionPageRequestJSON;
    @ViewChildren(MatAccordion) accordions: QueryList<MatAccordion>;
    // private questionDetailsHeaderRequestJSON: QuestionDetailsHeaderRequestJSON;
    // private surveyDeployerQuestionPageRequestJSON: SurveyDeployerQuestionPageRequestJSON;
    private questionPageDetailsResponseJSON: QuestionPageDetailsResponseJSON;
    private questionCardResponseJSONList: QuestionCardResponseJSON[];
    private pageHeaderResponseJSON: PageHeaderResponseJSON;
    private pageFooterResponseJSON: PageFooterResponseJSON;
    private responseData: SurveyDeployerQuestionsPageResponseJSON[];
    private readOnlyflag: boolean;
    private questionPageDetailsRequestJSON: QuestionPageDetailsRequestJSON;
    private email;
    private username;
    private companyName;
    private mobileNumber;
    private surveyUserGeneratedID;
    surveySubmitted: boolean = false;
    surveyEdittable : boolean = false;
    successMessage : string  = '';
    successFlag : boolean;
    errorMsg : string;
    errorFlag : boolean;
    displayExpandAll : boolean = false;
    private conatinResponses : boolean;
    surveyStatus: any;
    employeeCode: any;
    constructor(
        private requestService: RequestService,
        private validatorService: ValidatorService,
        private questionPageService: QuestionPageService,
        private router: Router) {
    }

    ngOnInit(): void {
        //Fetch Question Details
        this.email = this.requestService.getEmail();
        this.username = this.requestService.getUsername();
        this.surveyStatus = this.requestService.getSurveyStatus();
        this.companyName = this.requestService.getCompanyName();
        this.mobileNumber = this.requestService.getMobileNumber();
        this.employeeCode = this.requestService.getEmployeeCode();
        this.surveyUserGeneratedID = this.requestService.getSurveyUserGeneratedID();
        this.surveyDeployerQuestionPageRequestJSON.surveyUserID = this.surveyUserGeneratedID;
        this.getQuestionPageDetails(this.surveyDeployerQuestionPageRequestJSON.surveyID);
    }

    closeSuccessMessage() {
        this.successFlag = false;
        this.successMessage = null;
      }

    openAllAccordion() {
        this.accordions.forEach(accordion => {
            accordion.openAll();
            this.displayExpandAll = true;
        })
    }

      closeAllAccordion(){
        this.accordions.forEach(accordion =>{
            accordion.closeAll();
            this.displayExpandAll = false;
        })
    }

    getQuestionPageDetails(surveyID: Number) {
        this.questionPageDetailsResponseJSON = new QuestionPageDetailsResponseJSON;
        this.pageHeaderResponseJSON = new PageHeaderResponseJSON;
        this.pageFooterResponseJSON = new PageFooterResponseJSON;
        this.questionCardResponseJSONList = new Array<QuestionCardResponseJSON>();

        // this.getSurveyDeployerQuestionPageRequestJSON();
        this.loading = true;
        this.questionPageService.fetchQuestions(this.surveyDeployerQuestionPageRequestJSON).subscribe(out => {
            this.responseData = out.responseData;
            this.surveySubmitted = out.responseData[0].submitted;
            this.pageHeaderResponseJSON = out.responseData[0].questionPageHeaderResponseJSON;
            this.pageFooterResponseJSON = out.responseData[0].questionPageFooterResponseJSON;
            this.questionPageDetailsResponseJSON = out.responseData[0].questionPageDetailsResponseJSON;
            this.questionCardResponseJSONList = out.responseData[0].questionPageDetailsResponseJSON.questionCardResponseJSONList;
            this.checkIfSurveyEdittable(this.questionCardResponseJSONList);
            this.checkSurveyResponseIsComingOrNot(this.questionCardResponseJSONList);
            this.setSliderValueTOMin();
            this.hideQuestionIfAllCellsAreHidden();
            this.loading = false;
            localStorage.setItem('showPrintButton','true');
        }, err => {
            this.error = true;
            this.expire = false;
            this.thanks = false;
            this.loading = false;
        });
    }

    checkIfSurveyEdittable(questionCardResponseJSONList: QuestionCardResponseJSON[]) {
        if (questionCardResponseJSONList != null && questionCardResponseJSONList.length > 0) {
            for (let questionCard of questionCardResponseJSONList) {
                if (questionCard.priviledgeEditable) {
                    this.surveyEdittable = true;
                    break;
                }
            }
        }
    }

    checkSurveyResponseIsComingOrNot(questionCardResponseJSONList: QuestionCardResponseJSON[]) {
        if (questionCardResponseJSONList != null && questionCardResponseJSONList.length > 0) {
            for (let questionCard of questionCardResponseJSONList) {
                for (let questionOptionJSON of questionCard.questionOptionJSONList) {
                    if (questionOptionJSON.displayRoleResponseJSONList != null && questionOptionJSON.displayRoleResponseJSONList.length > 0) {
                        this.conatinResponses = true;
                        break;
                    }
                }
            }
        }
    }
    

    readOnlyState(inputHTMLComponentJSON) {
        // console.log(inputHTMLComponentJSON);
        if ((inputHTMLComponentJSON.viewable && !inputHTMLComponentJSON.editable)) {
            this.readOnlyflag = true;
        } else {
            this.readOnlyflag = false;
        }
        return this.readOnlyflag;
    }
    
    // radio button check event
    selectRadio(event, item, options, radioJSON, questionCardResponseJSON: QuestionCardResponseJSON, questionCardResponseJSONList, cellComponentDetail) {
        //hide error
        console.log(cellComponentDetail);
        this.removeError(radioJSON);
        // unselect other and select this item
        var targetElm;
        if (event.srcElement) {
            targetElm = event.srcElement;
        } else {
            targetElm = event.currentTarget;
        }
        if (targetElm.checked) {
            radioJSON.selectedRadio = item.index;
            if (questionCardResponseJSON.linkedCellTrackerMap) {
                var cellTrackers = Object.keys(questionCardResponseJSON.linkedCellTrackerMap);
                var selectedQuestionColumnValueID;
                var nonSelectedQuestionColumnValueIDs = [];
                radioJSON.cellInputHTMLComponentJSONList[0].optionList.forEach(element => {
                    if (radioJSON.selectedRadio == element.index) {
                        selectedQuestionColumnValueID = element.questionColumnValueID;
                    } else {
                        nonSelectedQuestionColumnValueIDs.push(element.questionColumnValueID);
                    }
                });
                if (cellTrackers) {
                    var linkedQuestionsToShow = questionCardResponseJSON.linkedCellTrackerMap[selectedQuestionColumnValueID];
                    var linkedQuestionsToHide = [];
                    nonSelectedQuestionColumnValueIDs.forEach(nonSelectedQuestionColumnValueID => {
                        if (questionCardResponseJSON.linkedCellTrackerMap[nonSelectedQuestionColumnValueID]) {
                            questionCardResponseJSON.linkedCellTrackerMap[nonSelectedQuestionColumnValueID].forEach(linkedCell => {
                                linkedQuestionsToHide.push(linkedCell);
                            });
                        }
                    });


                    if (linkedQuestionsToShow) {
                        //this.toggleLinkedCells(linkedQuestionsToShow, questionCardResponseJSONList, true);
                        this.toggleLinkedCellsForRadio(linkedQuestionsToShow, questionCardResponseJSONList, true, cellComponentDetail.cellTrackerID);
                    }
                    if (linkedQuestionsToHide) {
                        //this.toggleLinkedCells(linkedQuestionsToHide, questionCardResponseJSONList, false);
                        this.toggleLinkedCellsForRadio(linkedQuestionsToHide, questionCardResponseJSONList, false, cellComponentDetail.cellTrackerID);
                    }

                }
            }
        }
    }

    selectCheckbox(event, item, checkboxGroup, questionCardResponseJSON: QuestionCardResponseJSON, questionCardResponseJSONList: QuestionCardResponseJSON[]) {
        //hide error
        this.removeError(checkboxGroup);
        var targetElm;
        if(event.srcElement){
            targetElm=event.srcElement;
        } else {
            targetElm=event.currentTarget;
        }
        if (targetElm.checked) {
            if (checkboxGroup.selectedCheckBoxes == null || checkboxGroup.selectedCheckBoxes.length == 0) {
                checkboxGroup.selectedCheckBoxes = [item.index];
            } else {
                checkboxGroup.selectedCheckBoxes.push(item.index);
            }
            //show linked questions
            if (questionCardResponseJSON.linkedCellTrackerMap) {
                if (questionCardResponseJSON.linkedCellTrackerMap[item.questionColumnValueID]) {
                    var linkedQuestionsToShow = questionCardResponseJSON.linkedCellTrackerMap[item.questionColumnValueID];
                    this.toggleLinkedCells(linkedQuestionsToShow, questionCardResponseJSONList, true);
                }
            }
        } else {
            var index = checkboxGroup.selectedCheckBoxes.indexOf(item.index);
            checkboxGroup.selectedCheckBoxes.splice(index, 1);
            //hide linked questions
            if (questionCardResponseJSON.linkedCellTrackerMap) {
                if (questionCardResponseJSON.linkedCellTrackerMap[item.questionColumnValueID]) {
                    var linkedQuestionsToShow = questionCardResponseJSON.linkedCellTrackerMap[item.questionColumnValueID];
                    this.toggleLinkedCells(linkedQuestionsToShow, questionCardResponseJSONList, false);
                }
            }
        }

    }

    dropDownChange(event, item, options, questionCardResponseJSON: QuestionCardResponseJSON, questionCardResponseJSONList) {
        if (questionCardResponseJSON.linkedCellTrackerMap) {

            var cellTrackers = Object.keys(questionCardResponseJSON.linkedCellTrackerMap);
            var selectedQuestionColumnValueID;
            var nonSelectedQuestionColumnValueIDs = [];
            options.cellInputHTMLComponentJSONList[0].optionList.forEach(element => {
                if (options.selectedDropValue == element.index) {
                    selectedQuestionColumnValueID = element.questionColumnValueID;
                } else {
                    nonSelectedQuestionColumnValueIDs.push(element.questionColumnValueID);
                }
            });
            if (cellTrackers) {
                var linkedQuestionsToShow = questionCardResponseJSON.linkedCellTrackerMap[selectedQuestionColumnValueID];
                var linkedQuestionsToHide = [];
                nonSelectedQuestionColumnValueIDs.forEach(nonSelectedQuestionColumnValueID => {
                    if (questionCardResponseJSON.linkedCellTrackerMap[nonSelectedQuestionColumnValueID]) {
                        questionCardResponseJSON.linkedCellTrackerMap[nonSelectedQuestionColumnValueID].forEach(linkedCell => {
                            linkedQuestionsToHide.push(linkedCell);
                        });
                    }
                });
                if (linkedQuestionsToShow) {
                    this.toggleLinkedCells(linkedQuestionsToShow, questionCardResponseJSONList, true);
                }
                if (linkedQuestionsToHide) {
                    this.toggleLinkedCells(linkedQuestionsToHide, questionCardResponseJSONList, false);
                }
            }
        }
    }

    removeErrors(questions: QuestionPageDetailsResponseJSON) {
        questions["questionCardResponseJSONList"].forEach(card => {
            card["questionColumnJSONList"].forEach(cell => {
                cell["cellComponentDetailJSONList"].forEach(cellComponentDetail => {
                    cellComponentDetail["cellComponentJSON"]["cellErrorMessage"] = "";
                });
            });
        });
    }

    removeSliderCellErrors(questionColumnInstanceInner){
        questionColumnInstanceInner.cellComponentDetailJSONList[0].cellComponentJSON
    }

    removeError(cellComponentJSON) {
        cellComponentJSON.cellErrorMessage = "";
    }

    removeColumnError(questionCardResponseJSON, questionColumnInstanceInner) {
        questionColumnInstanceInner.columnErrorMessage = "";
        // this.sliderValueChanged(questionCardResponseJSON, questionColumnInstanceInner);
    }

    submitQuestions(questionPageDetailsResponseJSON: QuestionPageDetailsResponseJSON) {
        // will return questionPageDetailResponseJSON with updated error messages if validation fails 
        // otherwise false will be returned
        this.successFlag = false;
        this.errorFlag = false;
        var error = this.validatorService.validateCellValidation(questionPageDetailsResponseJSON);
        if (!error) {
            var error = this.validatorService.validateColumnValidation(questionPageDetailsResponseJSON);
        }
        if (error) {
            questionPageDetailsResponseJSON = error;
            this.errorFlag = true;
            this.errorMsg = "Please fill mandatory Questions";
            window.scroll(0,0);
            return;
        }
        var noQuestionFilledError = this.validatorService.checkingAtLeastOneQuestionIsFilledForSaving(questionPageDetailsResponseJSON);
        if (noQuestionFilledError) {
            this.errorFlag = true;
            this.errorMsg = "Please fill response";
            window.scroll(0,0);
            return;
        }
        // this.validatorService.validateColumnValidation(questionPageDetailsResponseJSON);
            error = this.validatorService.validateColumnValidation(questionPageDetailsResponseJSON);
            this.questionPageDetailsRequestJSON = this.convertQuestionPageDetailsRequestJSONToQuestionPageDetailsResponseJSON(questionPageDetailsResponseJSON);
            this.questionPageDetailsRequestJSON.surveyID = this.surveyDeployerQuestionPageRequestJSON.surveyID;
            this.questionPageDetailsRequestJSON.surveyDeployerWCPageRequestJSON = this.requestService.getSurveyDeployerWCPageRequestJSON();
            this.questionPageDetailsRequestJSON.surveyUserGeneratedID = this.surveyUserGeneratedID;
            this.loading = true;
            this.questionPageService.submitQuestions(this.questionPageDetailsRequestJSON)
                .subscribe(out => {
                    this.loading = false;
                    window.scroll(0,0);
                    if (out.response.pageRedirectTo == "Page404") {
                        this.error = true;
                        this.expire = false;
                        this.thanks = false;
                        this.loading = false;
                        localStorage.setItem('showPrintButton','false');
                    } else if (out.response.pageRedirectTo == "ExpirePage") {
                        this.error = false;
                        this.expire = true;
                        this.thanks = false;
                        this.loading = false;
                        localStorage.setItem('showPrintButton','false');
                    } else if (out.response.pageRedirectTo == "SurveyComplete") {
                        this.error = false;
                        this.expire = false;
                        this.thanks = true;
                        this.loading = false;
                        localStorage.setItem('showPrintButton','false');
                    }
                })
    }

    saveQuestions(questionPageDetailsResponseJSON: QuestionPageDetailsResponseJSON) {
        // will return questionPageDetailResponseJSON with updated error messages if validation fails 
        // otherwise false will be returned
        this.successFlag = false;
        this.errorFlag = false;
        var error = this.validatorService.checkingAtLeastOneQuestionIsFilledForSaving(questionPageDetailsResponseJSON);
        if (error) {
            this.errorFlag = true;
            this.errorMsg = "Please fill response";
            window.scroll(0,0);
            return;
        }else {
            this.questionPageDetailsRequestJSON = this.convertQuestionPageDetailsRequestJSONToQuestionPageDetailsResponseJSON(questionPageDetailsResponseJSON);
            this.questionPageDetailsRequestJSON.surveyID = this.surveyDeployerQuestionPageRequestJSON.surveyID;
            this.questionPageDetailsRequestJSON.surveyDeployerWCPageRequestJSON = this.requestService.getSurveyDeployerWCPageRequestJSON();
            this.questionPageDetailsRequestJSON.surveyUserGeneratedID = this.surveyUserGeneratedID;
            this.loading = true;
            this.questionPageService.saveQuestions(this.questionPageDetailsRequestJSON)
                .subscribe(out => {
                    this.loading = false;
                    window.scroll(0,0);
                    if (out.response.pageRedirectTo == "Page404") {
                        this.error = true;
                        this.expire = false;
                        this.thanks = false;
                        this.loading = false;
                    } else if (out.response.pageRedirectTo == "ExpirePage") {
                        this.error = false;
                        this.expire = true;
                        this.thanks = false;
                        this.loading = false;
                    } else if (out.response.pageRedirectTo == "SurveySaved") {
                        this.error = false;
                        this.expire = false;
                        this.thanks = false;
                        this.loading = false;
                        this.successFlag = true;
                        this.successMessage = "Survey Saved Successfully"
                        this.surveyStatus = 200;
                    }else if (out.response.pageRedirectTo == "SurveyComplete") {
                        this.error = false;
                        this.expire = false;
                        this.thanks = true;
                        this.loading = false;
                    }
                })
        }
    }

    convertQuestionPageDetailsRequestJSONToQuestionPageDetailsResponseJSON(questionPageDetailsResponseJSON: QuestionPageDetailsResponseJSON) {
        var questionPageDetailsRequestJSONObj = new QuestionPageDetailsRequestJSON;
        questionPageDetailsRequestJSONObj.questionCardResponseJSONList = this.convertQuestionCardResponseJSONListToQuestionCardRequestJSONList(questionPageDetailsResponseJSON.questionCardResponseJSONList);
        questionPageDetailsRequestJSONObj.questionDetailsHeaderResponseJSON = this.convertQuestionDetailsHeaderResponseJSONToQuestionDetailsHeaderRequestJSON(questionPageDetailsResponseJSON.questionDetailsHeaderResponseJSON);
        questionPageDetailsRequestJSONObj.surveyDeployerWCPageRequestJSON = questionPageDetailsResponseJSON.surveyDeployerWCPageRequestJSON;
        questionPageDetailsRequestJSONObj.surveyID = questionPageDetailsResponseJSON.surveyID;
        return questionPageDetailsRequestJSONObj;
    }

    convertQuestionCardResponseJSONListToQuestionCardRequestJSONList(questionCardResponseJSONList: QuestionCardResponseJSON[]) {
        var questionCardRequestJSONList = new Array<QuestionCardRequestJSON>();
        questionCardResponseJSONList.forEach(element => {
            var questionCardRequestJSON = new QuestionCardRequestJSON;
            questionCardRequestJSON.linkedCellTrackerMap = element.linkedCellTrackerMap;
            questionCardRequestJSON.linkedQuestion = element.linkedQuestion;
            questionCardRequestJSON.questionColumnJSONList = this.convertQuestionColumnJSONListToQuestionColumnResponseJSONList(element.questionColumnJSONList);
            questionCardRequestJSON.questionOptionJSONList = this.convertQuestionOptionJSONListToQuestionOptionRequestJSON(element.questionOptionJSONList);
            questionCardRequestJSON.questionTextJSON = this.convertQuestionJSONToQuestionRequestJSON(element.questionTextJSON);
            questionCardRequestJSON.priviledgeViewable = element.priviledgeViewable;
            questionCardRequestJSON.priviledgeEditable = element.priviledgeEditable;
            questionCardRequestJSON.rootLinkedQuestion = element.rootLinkedQuestion;
            questionCardRequestJSONList.push(questionCardRequestJSON);
        });
        return questionCardRequestJSONList;
    }

    convertQuestionOptionJSONListToQuestionOptionRequestJSON(questionOptionJSONList: QuestionOptionJSON[]) {
        var questionOptionRequestJSONList = new Array<QuestionOptionRequestJSON>();
        questionOptionJSONList.forEach(element => {
            var questionOptionRequestJSON = new QuestionOptionRequestJSON;
            questionOptionRequestJSON.optionTextComponentJSON = this.convertHTMLLabelComponentToHTMLGenricComponent(element.optionTextComponentJSON);
            questionOptionRequestJSON.sequence = element.sequence;
            questionOptionRequestJSON.displayRoleResponseJSONList = this.convertDisplayRoleResponseJSONListToDisplayRoleRequestJSONList(element.displayRoleResponseJSONList);
            questionOptionRequestJSONList.push(questionOptionRequestJSON);
        });
        return questionOptionRequestJSONList;
    }

    convertDisplayRoleResponseJSONListToDisplayRoleRequestJSONList(displayRoleResponseJSONList: DisplayRoleResponseJSON[]){
        var displayRoleRequestJSONList = null;
        if(displayRoleResponseJSONList && displayRoleResponseJSONList != null && displayRoleResponseJSONList.length>0){
            displayRoleRequestJSONList = new Array<DisplayRoleResponseJSON>();
            displayRoleResponseJSONList.forEach(element => {
            var displayRoleRequestJSON = new DisplayRoleResponseJSON;
            displayRoleRequestJSON.roleName = element.roleName;
            displayRoleRequestJSON.actorName = element.actorName;
            displayRoleRequestJSON.questionsAnswerString = element.questionsAnswerString;
            displayRoleRequestJSONList.push(displayRoleRequestJSON);
        });
    }
        return displayRoleRequestJSONList;
    }

    convertQuestionJSONToQuestionRequestJSON(questionJSON: QuestionJSON) {
        var questionRequestJSON = new QuestionRequestJSON;
        questionRequestJSON.questionID = questionJSON.questionID;
        questionRequestJSON.questionTextComponentJSON = this.convertHTMLLabelComponentToHTMLGenricComponent(questionJSON.questionTextComponentJSON);
        questionRequestJSON.sequence = questionJSON.sequence
        return questionRequestJSON;
    }

    convertQuestionColumnJSONListToQuestionColumnResponseJSONList(questionColumnJSONList: QuestionColumnJSON[]) {
        var questionColumnRequestJSONList = new Array<QuestionColumnRequestJSON>();
        questionColumnJSONList.forEach(element => {
            var questionColumnRequestJSON = new QuestionColumnRequestJSON;
            questionColumnRequestJSON.cellComponentDetailJSONList = this.convertCellComponentDetailJSONListToCellComponentDetailRequestJSONList(element.cellComponentDetailJSONList);
            questionColumnRequestJSON.columnSequence = element.columnSequence;
            questionColumnRequestJSON.columnTextComponentJSON = this.convertHTMLLabelComponentToHTMLGenricComponent(element.columnTextComponentJSON);
            questionColumnRequestJSON.columnValidationJSONList = element.columnValidationJSONList;
            questionColumnRequestJSON.componentTypeID = element.componentTypeID;
            questionColumnRequestJSON.optionTypeID = element.optionTypeID;
            questionColumnRequestJSON.questionColumnID = element.questionColumnID;
            questionColumnRequestJSON.valuesListForAColumnList = element.valuesListForAColumnList;
            questionColumnRequestJSONList.push(questionColumnRequestJSON);
        });
        return questionColumnRequestJSONList;
    }

    convertHTMLLabelComponentToHTMLGenricComponent(hTMLLabelComponent: HTMLLabelComponent) {
        var hTMLGenricComponent = new HTMLGenricComponent;
        var keys = Object.keys(hTMLLabelComponent);
        keys.forEach(key => {
            hTMLGenricComponent[key] = hTMLLabelComponent[key];
        });
        return hTMLGenricComponent;
    }

    convertCellComponentDetailJSONListToCellComponentDetailRequestJSONList(cellComponentDetailJSONList: CellComponentDetailJSON[]) {
        var cellComponentDetailRequestJSONList = new Array<CellComponentDetailRequestJSON>();

        cellComponentDetailJSONList.forEach(element => {
            var cellComponentDetailRequestJSON = new CellComponentDetailRequestJSON;
            cellComponentDetailRequestJSON.cellComponentJSON = this.convertCellComponentJSONToCellComponentRequestJSON(element.cellComponentJSON);
            cellComponentDetailRequestJSON.cellTrackerID = element.cellTrackerID;
            cellComponentDetailRequestJSON.columnIndexForTrackingCellIndex = element.columnIndexForTrackingCellIndex;
            cellComponentDetailRequestJSON.hasLinkedQuestion = element.hasLinkedQuestion;
            cellComponentDetailRequestJSON.isCellLevelValidationActivated = element.isCellLevelValidationActivated;
            cellComponentDetailRequestJSON.isMandatoryValidationActivated = element.isMandatoryValidationActivated;
            cellComponentDetailRequestJSON.isVisibleValidationActivated = element.isVisibleValidationActivated;
            cellComponentDetailRequestJSON.questionColumnID = element.questionColumnID;
            cellComponentDetailRequestJSON.questionID = element.questionID;
            cellComponentDetailRequestJSON.questionOptionID = element.questionOptionID;
            cellComponentDetailRequestJSON.rowIndexForTrackingCellIndex = element.rowIndexForTrackingCellIndex;
            cellComponentDetailRequestJSONList.push(cellComponentDetailRequestJSON);
        });
        return cellComponentDetailRequestJSONList;
    }

    convertCellComponentJSONToCellComponentRequestJSON(cellComponentJSON: CellComponentJSON) {
        var cellComponentRequestJSON = new CellComponentRequestJSON;
        cellComponentRequestJSON.cellErrorMessage = cellComponentJSON.cellErrorMessage;
        cellComponentRequestJSON.cellInputHTMLComponentJSONList = this.convertHTMLGenricComponentListToInputHTMLComponentJSONList(cellComponentJSON.cellInputHTMLComponentJSONList);
        cellComponentRequestJSON.cellLinkedToQuestion = cellComponentJSON.cellLinkedToQuestion;
        cellComponentRequestJSON.cellTrackerID = cellComponentJSON.cellTrackerID;
        cellComponentRequestJSON.cellValidationJSONList = cellComponentJSON.cellValidationJSONList;
        cellComponentRequestJSON.columnIndex = cellComponentJSON.columnIndex;
        cellComponentRequestJSON.hasPipedCellDetails = cellComponentJSON.hasPipedCellDetails;
        cellComponentRequestJSON.isCellLevelValidationActivated = cellComponentJSON.isCellLevelValidationActivated;
        cellComponentRequestJSON.isMandatoryValidationActivated = cellComponentJSON.isMandatoryValidationActivated;
        cellComponentRequestJSON.isVisibleValidationActivated = cellComponentJSON.isVisibleValidationActivated;
        cellComponentRequestJSON.questionColumnID = cellComponentJSON.questionColumnID;
        cellComponentRequestJSON.questionID = cellComponentJSON.questionID;
        cellComponentRequestJSON.questionOptionID = cellComponentJSON.questionOptionID;
        cellComponentRequestJSON.rowIndex = cellComponentJSON.rowIndex;
        cellComponentRequestJSON.selectedCheckBoxes = cellComponentJSON.selectedCheckBoxes;
        cellComponentRequestJSON.selectedDropValue = cellComponentJSON.selectedDropValue;
        cellComponentRequestJSON.selectedRadio = cellComponentJSON.selectedRadio;
        cellComponentRequestJSON.syscomponentTypeID = cellComponentJSON.syscomponentTypeID;
        return cellComponentRequestJSON;
    }

    convertQuestionDetailsHeaderResponseJSONToQuestionDetailsHeaderRequestJSON(questionDetailsHeaderResponseJSON: QuestionDetailsHeaderResponseJSON) {
        var questionDetailsHeaderRequestJSON = new QuestionDetailsHeaderRequestJSON;
        var hTMLDisplayComponentRequestJSONList = new Array<HTMLDisplayComponentRequestJSON>();
        questionDetailsHeaderResponseJSON.hHTMLDisplayComponentList.forEach(element => {
            var hTMLDisplayComponentRequestJSON = new HTMLDisplayComponentRequestJSON;
            hTMLDisplayComponentRequestJSON.componentTypeID = element.componentTypeID;
            hTMLDisplayComponentRequestJSON.displayLable = element.displayLable;
            hTMLDisplayComponentRequestJSON.selectedCheckBox = element.selectedCheckBox;
            hTMLDisplayComponentRequestJSON.selectedDropDown = element.selectedDropDown;
            hTMLDisplayComponentRequestJSON.selectedRadio = element.selectedRadio;
            hTMLDisplayComponentRequestJSON.inputHTMLComponentJSONList = this.convertHTMLGenricComponentListToInputHTMLComponentJSONList(element.inputHTMLComponentJSONList);
            hTMLDisplayComponentRequestJSONList.push(hTMLDisplayComponentRequestJSON);
        });
        questionDetailsHeaderRequestJSON.hHTMLDisplayComponentList = hTMLDisplayComponentRequestJSONList;
        questionDetailsHeaderRequestJSON.surveyID = questionDetailsHeaderResponseJSON.surveyID;
        questionDetailsHeaderRequestJSON.userName = questionDetailsHeaderResponseJSON.userName;
        questionDetailsHeaderRequestJSON.email = questionDetailsHeaderResponseJSON.email;
        return questionDetailsHeaderRequestJSON;
    }

    convertHTMLGenricComponentListToInputHTMLComponentJSONList(inputHTMLComponentJSON: InputHTMLComponentJSON[]) {
        //every Type
        var hTMLGenricComponentList = new Array<HTMLGenricComponent>();
        if(inputHTMLComponentJSON != null) {
            inputHTMLComponentJSON.forEach(element => {
                var hTMLGenricComponent = new HTMLGenricComponent;
                var keys = Object.keys(element);
                keys.forEach(key => {
                    hTMLGenricComponent[key] = element[key];
                });
                hTMLGenricComponentList.push(hTMLGenricComponent);
            });
        }        
        return hTMLGenricComponentList;
    }

    toggleLinkedCellsForRadio(linkedQuestions, questionCardResponseJSONList, show, currentCellTrackerId) {
        //show all linked Cells
        let nextLinkedQuestionParent;
        linkedQuestions.forEach(linkedQuestion => {
            questionCardResponseJSONList.forEach(questionCardResponseJSON => {
                if (!show && questionCardResponseJSON.questionTextJSON.questionID == linkedQuestion.questionID) {
                    nextLinkedQuestionParent = questionCardResponseJSON;
                }
                if (linkedQuestion && linkedQuestion.questionID && questionCardResponseJSON.questionTextJSON.questionID == linkedQuestion.questionID && linkedQuestion.parentCellTrackerID == currentCellTrackerId
                    &&(questionCardResponseJSON.priviledgeViewable || questionCardResponseJSON.priviledgeEditable)) {
                    questionCardResponseJSON.questionColumnJSONList.forEach(questionColumn => {
                        questionColumn.cellComponentDetailJSONList.forEach(cellComponentDetail => {
                            if (!show) {
                                cellComponentDetail.cellComponentJSON.selectedRadio = 0;
                                cellComponentDetail.cellComponentJSON.selectedDropValue = 0;
                                cellComponentDetail.cellComponentJSON.selectedCheckBoxes = null;
                            }
                            cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList.forEach(cellInputHTMLComponent => {
                                // hide/show cell
                                if (cellComponentDetail.cellTrackerID == linkedQuestion.childCellTrackerID) {
                                    cellInputHTMLComponent.viewable = show;
                                    if (!show) {
                                        cellInputHTMLComponent.value = null;
                                    }
                                }
                            })
                        })
                    });
                }
            });
        });
        if (!show && nextLinkedQuestionParent && nextLinkedQuestionParent.linkedCellTrackerMap) {
            this.hideChildLinkedQuestions(nextLinkedQuestionParent, questionCardResponseJSONList);
        }
        this.hideQuestionIfAllCellsAreHidden();
    }

    hideChildLinkedQuestions(nextLinkedQuestionParent: any, questionCardResponseJSONList: any) {
        if (!nextLinkedQuestionParent || !nextLinkedQuestionParent.linkedCellTrackerMap || !questionCardResponseJSONList) {
            return;
        }
        let map: any = nextLinkedQuestionParent.linkedCellTrackerMap;
        Object.keys(map).forEach((key) => {

            let questionIdToDecativate = map[key][0].questionID;
            for (let questionCard of questionCardResponseJSONList) {
                if (questionCard.questionTextJSON.questionID == questionIdToDecativate) {
                    nextLinkedQuestionParent = questionCard;
                    break;
                }
            }
            this.hideChildLinkedQuestions(nextLinkedQuestionParent, questionCardResponseJSONList);
            nextLinkedQuestionParent.questionColumnJSONList.forEach(questionColumn => {
                questionColumn.cellComponentDetailJSONList.forEach(cellComponentDetail => {
                    cellComponentDetail.cellComponentJSON.selectedRadio = 0;

                    cellComponentDetail.cellComponentJSON.selectedDropValue = 0;
                    cellComponentDetail.cellComponentJSON.selectedCheckBoxes = null;
                    cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList.forEach(cellInputHTMLComponent => {
                        cellInputHTMLComponent.viewable = false;
                        cellInputHTMLComponent.value = null;
                    })
                })
            });
        });
    }

    toggleLinkedCells(linkedQuestions, questionCardResponseJSONList, show) {
        //show all linked Cells
        linkedQuestions.forEach(linkedQuestion => {
            questionCardResponseJSONList.forEach(questionCardResponseJSON => {
                if (linkedQuestion && linkedQuestion.questionID && questionCardResponseJSON.questionTextJSON.questionID == linkedQuestion.questionID ) {
                    questionCardResponseJSON.questionColumnJSONList.forEach(questionColumn => {
                        questionColumn.cellComponentDetailJSONList.forEach(cellComponentDetail => {
                            cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList.forEach(cellInputHTMLComponent => {
                                    // hide/show cell
                                    cellInputHTMLComponent.viewable = show;
                                   
                                })
                            
                        })
                    });
                }
            });
        });
        this.hideQuestionIfAllCellsAreHidden();
    }

    setSliderValueTOMin(){
        this.questionCardResponseJSONList.forEach(questionCardResponseJSON => {
            var questionIsViewable = false;
            questionCardResponseJSON.questionColumnJSONList.forEach(questionColumnInstance => {
                questionColumnInstance.cellComponentDetailJSONList.forEach(cellComponentDetail => {
                    if(cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList != null) {
                        cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList.forEach(cellInputHTMLComponent => {
                            if (cellInputHTMLComponent.type==9) {
                                cellInputHTMLComponent.value=cellInputHTMLComponent['minInt'];
                            }
                        });
                    }                    
                });
            });
        })
    }

    hideQuestionIfAllCellsAreHidden() {
        this.questionCardResponseJSONList.forEach(questionCardResponseJSON => {
            var questionIsViewable = false;
            questionCardResponseJSON.questionColumnJSONList.forEach(questionColumnInstance => {
                questionColumnInstance.cellComponentDetailJSONList.forEach(cellComponentDetail => {
                    if(cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList != null) {
                        cellComponentDetail.cellComponentJSON.cellInputHTMLComponentJSONList.forEach(cellInputHTMLComponent => {
                            if (cellInputHTMLComponent.viewable == true) {
                                questionIsViewable = true;
                            }
                        });
                    }                    
                })
            })
            if (questionIsViewable) {
                questionCardResponseJSON.questionTextJSON.questionTextComponentJSON.viewable = true;
            } else {
                questionCardResponseJSON.questionTextJSON.questionTextComponentJSON.viewable = false;
            }
        })
    }

    sliderValueChanged(questionCardResponseJSON, questionColumnInstanceInner) {
        console.log(questionColumnInstanceInner);
        let total = 0;
        questionColumnInstanceInner.cellComponentDetailJSONList.forEach(cellComponentDetailJSON => {
            if (cellComponentDetailJSON.cellComponentJSON.cellInputHTMLComponentJSONList[0].value) {
                total += cellComponentDetailJSON.cellComponentJSON.cellInputHTMLComponentJSONList[0].value;
            }
        });
        if(questionColumnInstanceInner.columnValidationJSONList && questionColumnInstanceInner.columnValidationJSONList[0].columnLevelValidationValueMapperJSONList[0] && questionColumnInstanceInner.columnValidationJSONList[0].columnLevelValidationValueMapperJSONList[0].value){  
            if (total != 100) {
                questionCardResponseJSON.cardMessage = "current total: " + total + "% ,required total: " + questionColumnInstanceInner.columnValidationJSONList[0].columnLevelValidationValueMapperJSONList[0].value+"%";
            } else {
                questionCardResponseJSON.cardMessage="";
            }
        }
    }

    // showValue(newValue:any) {
    //     document.getElementById("range").innerHTML = newValue;
    // }
}
